var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxesIncomplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feature=Taxes, Status=Incomplete"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3162",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F4F6F9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "guest-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40589 13.996C9.72504 11.5795 11.5795 9.72504 13.996 9.40589C15.6573 9.18649 17.7354 9 20 9C22.2646 9 24.3427 9.18649 26.004 9.40589C28.4205 9.72504 30.275 11.5795 30.5941 13.996C30.8135 15.6573 31 17.7354 31 20C31 22.2646 30.8135 24.3427 30.5941 26.004C30.275 28.4205 28.4205 30.275 26.004 30.5941C24.3427 30.8135 22.2646 31 20 31C17.7354 31 15.6573 30.8135 13.996 30.5941C11.5795 30.275 9.72504 28.4205 9.40589 26.004C9.18649 24.3427 9 22.2646 9 20C9 17.7354 9.18649 15.6573 9.40589 13.996ZM18.2299 21.9402L17.9922 22.5967C17.9045 22.8388 17.6746 23 17.4172 23C16.9809 23 16.6849 22.5561 16.8528 22.1534L18.8077 17.4615C18.9241 17.1821 19.1972 17 19.5 17C19.8028 17 20.0759 17.1821 20.1923 17.4615L22.1088 22.0612C22.2949 22.5078 21.9668 23 21.483 23C21.1975 23 20.9426 22.8213 20.8454 22.5528L20.6236 21.9402H18.2299ZM20.2216 20.812L19.4268 18.6154L18.641 20.812H20.2216ZM15.3756 17.0001C15.699 17.0001 15.9611 17.2622 15.9611 17.5855C15.9611 17.9089 15.699 18.171 15.3756 18.171H14.2617V22.2189C14.2617 22.6503 13.912 23.0001 13.4806 23.0001C13.0491 23.0001 12.6994 22.6503 12.6994 22.2189V18.171H11.5855C11.2621 18.171 11 17.9089 11 17.5855C11 17.2622 11.2621 17.0001 11.5855 17.0001H15.3756ZM26.9605 22.6888C27.0994 22.8841 27.3241 23.0001 27.5637 23.0001C28.1654 23.0001 28.5156 22.3204 28.1665 21.8304L26.8803 20.0257L28.1532 18.1354C28.4791 17.6515 28.1323 17.0001 27.549 17.0001C27.2978 17.0001 27.0644 17.1294 26.9313 17.3423L26.0124 18.812L24.9454 17.3113C24.8066 17.116 24.5818 17.0001 24.3422 17.0001C23.7406 17.0001 23.3904 17.6798 23.7395 18.1697L25.0074 19.9488L23.7167 21.8645C23.3907 22.3484 23.7374 23.0001 24.3209 23.0001C24.5718 23.0001 24.805 22.8709 24.9382 22.6583L25.8753 21.1624L26.9605 22.6888Z",
    fill: "url(#paint0_radial_23_8618)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_23_8618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(11)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ADC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxesIncomplete);
export default __webpack_public_path__ + "static/media/taxes-incomplete.becc91d3368eb46b5d1adbc78bd9ea2a.svg";
export { ForwardRef as ReactComponent };